@if (visible()) {
  <article class="fixed inset-0 z-100 flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div class="bg-blue-primary flex max-w-md flex-col gap-4 rounded-sm p-6 text-center shadow-xl">
      <date-tag [text]="headetText()"></date-tag>
      <div class="bg-bg-base flex flex-col items-center gap-4 rounded-md p-3">
        <img
          class="size-16"
          [src]="image()"
          alt="info" />
        <h2 class="text-blue-cyan-light leading-6 font-black italic">{{ title() }}</h2>
        <p class="text-sm leading-5 font-semibold">
          {{ description() }}
        </p>
      </div>
      <div class="flex items-center justify-between gap-2">
        <button
          (click)="onPrimaryClick()"
          class="button1 w-full">
          {{ buttonText() }}
        </button>
        @if (secondaryButton()) {
          <button
            (click)="onSecondaryClick()"
            class="button1 w-full"
            style="background: var(--color-red-error)">
            Cerrar
          </button>
        }
      </div>
    </div>
  </article>
}
